import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import './appBtn.scss';
import {connect} from 'react-redux';
import {refresh_admin} from './../../redux/models/admin';
import $ from 'jquery'
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import Tool from '../../utils/tool';
// 打开东城app按钮公共组件
@connect(
  state => ({admin: state.admin}),
  {refresh_admin}
)
@withRouter
class AppBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {};

  }

  componentWillMount() {

  }

  componentDidMount() {
    $('#root').on('click', '.inBrowserBtn', function () {
      const _hostname = window.location.hostname;
      let downloadUrl = 'https://bj-dongcheng.oss-cn-beijing.aliyuncs.com/package/2020/02/22/4895279775507097290.apk'
      if (_hostname === 'cms-bjnews.foundao.com' || _hostname === 'localhost:3000' || _hostname === '192.168.31.145'
      || _hostname === 'cms-bjnews.iuxiao.com' || _hostname === 'bjdcweb-test.bjnews.com.cn') {   //测试环境
        downloadUrl = 'https://test-bjnews.oss-cn-beijing.aliyuncs.com/package/2020/01/02/4876783922882590436.apk'
      }
      window.open(downloadUrl,'_self')
    })
  }

  componentWillUnmount() {

  }

  // weiXinBtn = () => {
  //   alert('点击右上角按钮，然后在弹出的菜单中，点击浏览器中打开，即可安装')
  // } 

  // shouldComponentUpdate() {
  //
  // }

  render() {
    const is_dongcheng = Tool.is_dongcheng();
    return (
      <div className={classnames('open-app', {hidden: is_dongcheng})} style={this.props.style} onClick={this.openApp}>{this.props.text}</div>
    );
  }

  // openApp=()=> {
  //   const {name,uuid} = this.props
  //   var download_url = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bjnews.dongcheng'
  //   var ios_download_url = 'http://itunes.apple.com/cn/app/id1459595192?mt=8'
  //   var ios_url = 'com.foundaoDongCheng://'
  //   var android_url = 'com.foundao.dongcheng://bjnews.com/action?'
  //   // var android_url = 'com.bjnews.dongcheng://bjnews.com/action?'
  //   const iosUrl = ios_url + name + '/' + uuid
  //   const androidUrl = android_url + 'name='+ name + '&uuid='+ uuid
  //   if(this._isWeiXin()){   //判断是否是在微信中打开
  //     this.openAppInWeixin(iosUrl,androidUrl)
  //   }else {
  //     var userAgent = this.userAgent()
  //     if( userAgent === 0){   //ios环境
  //       window.location.href = iosUrl
  //       setTimeout(function () {
  //         window.location.href = ios_download_url
  //       },2000)
  //     } else if ( userAgent === 1){  // 安卓环境
  //       window.location.href = androidUrl
  //       var last = Date.now()
  //       //程序切换到后台，计时器会被推迟
  //       setTimeout(function () {
  //         if (Date.now() - last <= 2000) {
  //           // window.location.href = download_url;;    // 唤起失败，进入下载页
  //           const wxBrowser = <div className='browserContainer'>
  //                         <div className="content">
  //                           <div className="logoBox"><div></div></div>
  //                           <div className="title">北京东城客户端</div>
  //                           <div className="subTitle"><span>聚焦东城</span><span>智慧便民</span></div>
  //                           <div className="download">
  //                             <div className="downloadBtn inBrowserBtn"></div>
  //                           </div>
  //                         </div>
  //                       </div>
  //           ReactDOM.render(wxBrowser, document.getElementById('root'));
  //         } else {
  //           // 呼起成功
  //         }
  //       }, 1600);
  //     }
  //   }
  // }
  // // 唤起app的微信流程,微信中无法直接呼起app，安卓需要通过中间去去浏览器打开
  // openAppInWeixin =(iosUrl,androidUrl)=> {
  //   // var download_url = 'https://android.myapp.com/myapp/detail.htm?apkName=com.foundao.bjnews'
  //   var userAgent = this.userAgent();
  //   if (userAgent === 0) {   // ios
  //     // ios在微信中需要右上角通过浏览器打开
  //     // this.open_wxShow();
  //     // alert('ios')
  //     // window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.foundao.bjnews&android_schema=' + encodeURIComponent(iosUrl);
  //     window.location.href = 'http://itunes.apple.com/cn/app/id1459595192?mt=8'
  //   } else if (userAgent === 1) { // 安卓 通过中间页
  //     const wxBrowser = <div className='wxBrowserContainer'>
  //                         <div className="content">
  //                           <div className="header">
  //                             <div className="hintText">已安装北京东城客户端</div>
  //                             <div className="handle">
  //                               点击<span className='hintIcon'></span>
  //                               使用浏览器<span className='browserIcon'></span>打开
  //                             </div>
  //                           </div>
  //                           <div className="download">
  //                             <div className="downloadBtn" onClick={this.weiXinBtn}></div>
  //                           </div>
  //                         </div>
  //                       </div>
  //     ReactDOM.render(wxBrowser, document.getElementById('root'));
  //     // window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bjnews.dongcheng';
  //   }
  // };

  weiXinBtn = () => {
    var ios_app_url = 'https://apps.apple.com/cn/app/%E5%8C%97%E4%BA%AC%E4%B8%9C%E5%9F%8E/id1459595192'
    var userAgent = this.userAgent()
    if(userAgent === 0) {
      window.open(ios_app_url)
    } else {
      alert('点击右上角按钮，然后在弹出的菜单中，点击浏览器中打开，即可安装')
      console.log('Android')
    }
  } 

openApp = () => {

  console.log(this.props)
  const {name, uuid} = this.props
  console.log(name, uuid,'data')
  var download_url = 'https://bj-dongcheng.oss-cn-beijing.aliyuncs.com/package/2020/12/16/5003313083700028486.apk'
  var ios_app_url = 'https://apps.apple.com/cn/app/%E5%8C%97%E4%BA%AC%E4%B8%9C%E5%9F%8E/id1459595192'
  var ios_download_url = 'http://itunes.apple.com/cn/app/id1459595192?mt=8'
  var ios_url = 'com.foundaoDongCheng://'
  var android_url = 'com.foundao.dongcheng://bjnews.com/action?'
  const iosUrl = ios_url + name + '/' + uuid
  const androidUrl = android_url + 'name=' + name + '&uuid=' + uuid
  console.log(androidUrl)

  if (this._isWeiXin()) {   //判断是否是在微信中打开
    // this.openAppInWeixin(iosUrl, androidUrl)
    this.props.history.push(`/middlePage/url=${this.userAgent() === 0 ? iosUrl : androidUrl}`)

  } else {
    var userAgent = this.userAgent()
    if (userAgent === 0) {   //ios环境
      window.location.href = iosUrl
      var last = Date.now()
      // return false
      //程序切换到后台，计时器会被推迟
      setTimeout( () => {
        if (Date.now() - last <= 2000) {
          //唤起失败，进入下载页
          // window.location.href = download_url;
          // const wxBrowser = <div className='browserContainer' onClick={this.test}>
          //               <div className="content">
          //                 <div className="logoBox"><div></div></div>
          //                 <div className="title">北京东城客户端</div>
          //                 <div className="subTitle"><span>聚焦东城</span><span>智慧便民</span></div>
          //                 <div className="download">
          //                   <div className="downloadBtn inBrowserBtn" onClick={() => {window.location.href = ios_app_url}}></div>
          //                 </div>
          //               </div>
          //             </div>
          // ReactDOM.render(wxBrowser, document.getElementById('root'));
          this.props.history.push(`/middlePage/url=${iosUrl}`)
        }
      }, 1600)
      // setTimeout(function () {
      //   window.location.href = ios_download_url
      // }, 2000)
    } else if (userAgent === 1) {  // 安卓环境
      window.location.href = androidUrl
      var last = Date.now()
      // return false
      //程序切换到后台，计时器会被推迟
      setTimeout( () => {
        if (Date.now() - last <= 2000) {
          //唤起失败，进入下载页
          // window.location.href = download_url;
          // const wxBrowser = <div className='browserContainer' onClick={this.test}>
          //               <div className="content">
          //                 <div className="logoBox"><div></div></div>
          //                 <div className="title">北京东城客户端</div>
          //                 <div className="subTitle"><span>聚焦东城</span><span>智慧便民</span></div>
          //                 <div className="download">
          //                   <div className="downloadBtn inBrowserBtn" onClick={() => {window.location.href = download_url}}></div>
          //                 </div>
          //               </div>
          //             </div>
          // ReactDOM.render(wxBrowser, document.getElementById('root'));
          this.props.history.push(`/middlePage/url=${androidUrl}`)
        }
      }, 1600)
    } 
  }
}
// 唤起app的微信流程,微信中无法直接呼起app，安卓需要通过应用宝流程
openAppInWeixin =(iosUrl,androidUrl)=> {
  var download_url = 'https://android.myapp.com/myapp/detail.htm?apkName=com.foundao.bjnews'
  var userAgent = this.userAgent();
  // if (userAgent === 0) {   // ios
  //   window.location.href = 'http://itunes.apple.com/cn/app/id1459595192?mt=8'
  // } else if (userAgent === 1) { // 安卓 通过中间页
  //   const wxBrowser = <div className='wxBrowserContainer'>
  //                       <div className="content">
  //                         <div className="header">
  //                           <div className="hintText">已安装北京东城客户端</div>
  //                           <div className="handle">
  //                             点击<span className='hintIcon'></span>
  //                             使用浏览器<span className='browserIcon'></span>打开
  //                           </div>
  //                         </div>
  //                         <div className="download">
  //                           <div className="downloadBtn" onClick={this.weiXinBtn}></div>
  //                         </div>
  //                       </div>
  //                     </div>
  //   ReactDOM.render(wxBrowser, document.getElementById('root'));
  //   // window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bjnews.dongcheng';
  // }
  const wxBrowser = <div className='wxBrowserContainer'>
                        <div className="content">
                          <div className="header">
                            <div className="hintText">已安装北京东城客户端</div>
                            <div className="handle">
                              点击<span className='hintIcon'></span>
                              使用浏览器<span className='browserIcon'></span>打开
                            </div>
                          </div>
                          <div className="pointer">
                          </div>
                          <div className="download">
                            <div className="downloadBtn" onClick={this.weiXinBtn}></div>
                          </div>
                        </div>
                      </div>
    ReactDOM.render(wxBrowser, document.getElementById('root'));
};
  // 打开关闭微信浮层
  open_wxShow=()=> {
    const wx_show = document.querySelector('.wx_show');
    wx_show.style.display = 'block';
  }
  
  close_wxShow=()=>{
    const wx_show = document.querySelector('.wx_show');
    wx_show.style.display = 'none';
  }

  // 判断是安卓还是苹果
  userAgent = () => {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return 0;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      return 1;
    }
  };
  // 判断链接是不是在微信中打开
  _isWeiXin = () => {
    return /micromessenger/.test(navigator.userAgent.toLowerCase());
  };
}

export default AppBtn;


// WEBPACK FOOTER //
// ./src/components/AppBtn/appBtn.js